/**
 * @file Arquivo de scripts principal do sistema, incluído em todas as páginas.
 **/

import { solicitaConfirmacao } from "./alertas.js";
import { bootTomSelect } from "./drop-downs.js";
import { bootGenericos } from "./genericos.js";
import { bootInputMasks } from "./mascaras.js";
import { bootRowInputs } from "./row-inputs.js";
import { ensureElement } from "./utils.js";

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", load);
else load();

function load() {
  bootGenericos();
  bootAutoNavigate();
  bootAutoSubmit();
  bootAutoConfirm();
  bootRowInputs();
  bootInputMasks();
  bootTomSelect();
}

/**
 * Captura cliques em elementos input com atributo `data-url`,
 * direcionando o navegador para a URL especificada no mesmo.
 */
function bootAutoNavigate() {
  document.addEventListener("click", e => {
    if (e.target instanceof HTMLElement && e.target.matches("input[data-url]") && e.target.dataset.url)
      location.href = e.target.dataset.url;
  });
}

/**
 * Captura alterações em drop-downs com atributo `data-auto-submit`,
 * forçando um submit do formulário ao selecionar um item.
 */
function bootAutoSubmit() {
  document.addEventListener("input", e => {
    if (e.target instanceof HTMLElement && e.target.matches("[data-auto-submit]")) e.target.closest("form")?.submit();
  });
}

/**
 * Captura cliques em botões de formulários com atributo `data-confirm-question`,
 * exibindo uma pergunta de confirmação antes de enviar o formulário.
 */
function bootAutoConfirm() {
  document.addEventListener("submit", e => {
    const pergunta = e.submitter?.dataset.confirmQuestion;
    if (!pergunta) return;

    const form = ensureElement(HTMLFormElement, e.target);

    e.preventDefault();

    const btn = e.submitter; // captura botão na closure, caso contrário o evento se perderá
    solicitaConfirmacao({ pergunta }).then(ok => {
      if (!ok) return;

      delete btn.dataset.confirmQuestion; // deleta a pergunta, como forma de controlar múltiplos cliques
      form.requestSubmit(btn);
    });
  });
}
